import { WolverineDate } from '@app/types/wolverine-date';

type ChargeType =
  | 'Month'
  | 'Quarter'
  | 'Semi_Annual'
  | 'Annual'
  | 'Eighteen_Months'
  | 'Specific_Months'
  | 'Two_Years'
  | 'Three_Years';

export const FINANCED_CHARGE_TYPES = ['Month', 'Quarter'];

export interface RatePlan {
  autoRenew: boolean;
  charge: ChargeType;
  currency: string;
  nextChargeAmount: number;
  nextChargeDate: WolverineDate;
  productName: string;
  quantity: number;
  ratePlanName: string;
  renewalDate: WolverineDate;
  startDate: WolverineDate;
}
